import { crudRequest } from '@/services/api';

const params = {}
export default {
    namespace: 'sitesentdeparture',
    state: {
        detailCenter: '',
        onSearch: false,
        centerFilter: ''
    },

    effects: {
    },

    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
    }
}
